export default __webpack_public_path__ + "static/media/Teresa Keng.62b97c65.jpg";